"use client"

export function TopBar() {
  return (
    <header className="flex h-16 items-center justify-end bg-[var(--surface)] px-4">
      {/* Empty header maintained for layout stability */}
      {/* Identity controls moved to bottom-left org dropdown in sidebar */}
    </header>
  )
}
